import type { KeyboardEvent } from 'react';

import { clickCopyButton } from '@fragment/ui/src/components/IdCopyButton/IdCopyButton';
import { type NavTableProps } from '@fragment/ui/src/components/Table/NavTable';

/** Default keyboard shortcuts for NavTables with a single ID copy button */
export const copyRowIdShortcut: NavTableProps<{
  id: string;
}>['keyboardShortcuts'] = {
  c: {
    handleKeyPress: ({ id }, ev: KeyboardEvent) =>
      clickCopyButton(id, ev.currentTarget),
  },
};

export const makeCopyShortcut = <K extends string, T extends Record<K, string>>(
  key: K,
  shortcut = 'c'
) => ({
  [shortcut]: {
    handleKeyPress: (row: T, ev: KeyboardEvent) =>
      clickCopyButton(row[key], ev.currentTarget),
  },
});
